<template>
  <div class="login">
    <h1 class="section-title">
      {{ $t("login") }}
    </h1>
    <van-form @submit="onSubmit">
      <van-field
        v-model="email"
        :name="$t('email')"
        :label="$t('email')"
        :placeholder="$t('email')"
        :rules="[{ required: true, message: $t('email is required') }]"
      />
      <van-field
        v-model="password"
        type="password"
        :name="$t('password')"
        :label="$t('password')"
        :placeholder="$t('password')"
        :rules="[{ required: true, message: $t('password is required') }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          {{ $t("login") }}
        </van-button>
      </div>
      <div class="center-me">
        <router-link
          :to="{ name: 'forget-password' }"
          style="padding-left:5px;"
        >
          {{ $t("forgot password?") }}
        </router-link>
        <router-link :to="{ name: 'register' }" style="padding-left:5px;">
          {{ $t("register") }}
        </router-link>
      </div>
      <div class="center-me" style="margin-top:10px;">
        <FacebookLoginBtn v-if="false" />
        <GoogleLoginBtn />
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import FacebookLoginBtn from "@/components/FacebookLoginBtn";
import GoogleLoginBtn from "@/components/GoogleLoginBtn";
export default {
  name: "Login",
  components: { FacebookLoginBtn, GoogleLoginBtn },
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    ...mapActions("account", ["login"]),
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    onSubmit() {
      const { email, password } = this;
      const creds = { email, password };
      this.login(creds);
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("login"));
  }
};
</script>
